import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, Box, Typography, Button } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const ApiErrorModal = ({ requestKey, errorMessage, onClose, onRetry }) => {
  const apiStatus = useSelector((state) => state.apiStatus[requestKey]);

  // Sadece error varsa modal göster
  if (!apiStatus?.error) return null;

  const buttonStyle = {
    height: '36px',
    backgroundColor: '#10a37f',
    '&:hover': {
      backgroundColor: '#0e906f',
    },
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    flex: 1,
  };

  const outlineButtonStyle = {
    height: '36px',
    borderColor: '#d32f2f',
    color: '#d32f2f',
    '&:hover': {
      borderColor: '#d32f2f',
      backgroundColor: 'transparent',
    },
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    flex: 1,
  };

  return (
    <Modal open={true}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 400 },
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            mb: 3,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 3 }}>
            <ErrorIcon sx={{ color: '#d32f2f', fontSize: 28 }} />
            <Typography sx={{ fontSize: '1rem' }}>
              {errorMessage}
              {apiStatus.error && apiStatus.error !== errorMessage && (
                <span style={{ color: '#666', fontWeight: 'normal' }}>: {apiStatus.error}</span>
              )}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            mt: 1,
            mb: 2,
            maxWidth: '320px',
            mx: { xs: 0, sm: 'auto' },
            width: '100%',
          }}
        >
          <Button disableRipple variant="outlined" onClick={onClose} sx={outlineButtonStyle}>
            Kapat
          </Button>
          {onRetry && (
            <Button disableRipple variant="contained" onClick={onRetry} sx={buttonStyle}>
              Tekrar Dene
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ApiErrorModal;
